import {
  CREATE_BASKET,
  ADD_ITEM_TO_BASKET,
  REMOVE_ITEM_FROM_BASKET,
  BASKET_SYNCED_ITEM,
  BASKET_SYNC_ITEM,
  BASKET_SYNC_FAILED_ITEM,
  CLEAR_BASKET,
} from "./types";
import {
  create_basket_util,
  add_item_util,
  remove_item_util,
  sync_item_util,
  synced_item_util,
  sync_failed_item_util,
  reducer_logout_basket,
} from "./utils";

import { init_state } from "./config";

import globalTypes from "../global/types";

/*
  Queue proposal:
    We are syncing our store with server.
    in first step we are going to have the online actions
    and in second step we will let the users to create
    and update their basket offline then everything
    will be synced when the connection back. 
    
    example for offline:
{
  actions: {
    "select_address": {
      // ...
    }
  },
  items: {
    "basket_id": {
      status,
      quantity
    },
    "12": {
      status: "loading", // not_synced
      quantity: 5
    }
  }
};

*/

export default function basketReducer(state = init_state, action) {
  switch (action.type) {
    case CREATE_BASKET:
      return create_basket_util(state, action.payload);
    case ADD_ITEM_TO_BASKET:
      return add_item_util(state, action.payload);
    case REMOVE_ITEM_FROM_BASKET:
      return remove_item_util(state, action.payload);
    case BASKET_SYNC_ITEM:
      return sync_item_util(state, action.payload);
    case BASKET_SYNCED_ITEM:
      return synced_item_util(state, action.payload);
    case BASKET_SYNC_FAILED_ITEM:
      return sync_failed_item_util(state, action.payload);
    case CLEAR_BASKET:
      return init_state;
    case globalTypes.LOGOUT:
      return reducer_logout_basket(state);
    default:
      return state;
  }
}
